import { render, staticRenderFns } from "./story.vue?vue&type=template&id=a7e4edb6&scoped=true&lang=true&"
import script from "./story.vue?vue&type=script&lang=js&"
export * from "./story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e4edb6",
  null
  
)

export default component.exports